import React from "react";
import { useLocation } from "react-router-dom";
import Barcode from "react-barcode";
import "styles/printLabelManual.scss";

function PrintLabelManual() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  React.useEffect(() => {
    window.print();
    window.onafterprint = window.close;
  }, []);

  return (
    <>
      <div className='print-label-manual'>
        <div className='label'>
          <div className='barcode'>
            <Barcode
              value={query.get("no_rm")}
              height={30}
              width={2.7}
              displayValue={false}
            />
          </div>
          <div className='pasien'>
            <p>{query.get("name")}</p>
            <p>{query.get("umur")}</p>
            <p>{query.get("regis")}</p>
            <p>NIK. {query.get("nik")}</p>
            <p>{query.get("dokter")}</p>
            <p>{query.get("insurance")}</p>
            <p>
              Tgl :{" "}
              <span
                style={{
                  margin: "0 10px",
                }}></span>{" "}
              {query.get("tanggal")}
            </p>
          </div>
        </div>

        <div className='label'>
          <div className='barcode'>
            <Barcode
              value={query.get("no_rm")}
              height={30}
              width={2.7}
              displayValue={false}
            />
          </div>
          <div className='pasien'>
            <p>{query.get("name")}</p>
            <p>{query.get("umur")}</p>
            <p>{query.get("regis")}</p>
            <p>NIK. {query.get("nik")}</p>
            <p>{query.get("dokter")}</p>
            <p>{query.get("insurance")}</p>
            <p>
              Tgl :{" "}
              <span
                style={{
                  margin: "0 10px",
                }}></span>{" "}
              {query.get("tanggal")}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrintLabelManual;
